import lockCheck from '@iconify/icons-mdi/lock-check';
import lockOpenVariant from '@iconify/icons-mdi/lock-open-variant';
import fileUndo from '@iconify/icons-mdi/file-undo';
import chevronDoubleLeft from '@iconify/icons-mdi/chevron-double-left';
import chevronDoubleRight from '@iconify/icons-mdi/chevron-double-right';
import chevronLeft from '@iconify/icons-mdi/chevron-left';
import chevronRight from '@iconify/icons-mdi/chevron-right';
import chevronDown from '@iconify/icons-mdi/chevron-down';
import chevronUp from '@iconify/icons-mdi/chevron-up';
import pauseIcon from '@iconify/icons-mdi/pause';
import playIcon from '@iconify/icons-mdi/play';
import replayIcon from '@iconify/icons-mdi/replay';
import checkIcon from '@iconify/icons-mdi/check';
import stopIcon from '@iconify/icons-mdi/stop';
import deleteIcon from '@iconify/icons-mdi/delete';
import undoIcon from '@iconify/icons-mdi/undo';
//import alertIcon from '@iconify/icons-mdi/alert';
import alertCircle from '@iconify/icons-mdi/alert-circle';
import databaseIcon from '@iconify/icons-mdi/database';
import pencilIcon from '@iconify/icons-mdi/pencil';
import toolsIcon from '@iconify/icons-mdi/tools';
import cogIcon from '@iconify/icons-mdi/cog';
import closeIcon from '@iconify/icons-mdi/close';
import catIcon from '@iconify/icons-mdi/cat';
import trashCan from '@iconify/icons-mdi/trash-can';
import leadPencil from '@iconify/icons-mdi/lead-pencil';
import viewDashboard from '@iconify/icons-mdi/view-dashboard';
import databaseSearch from '@iconify/icons-mdi/database-search';
import folderIcon from '@iconify/icons-mdi/folder';
import folderOpen from '@iconify/icons-mdi/folder-open';
import imageMultipleOutline from '@iconify/icons-mdi/image-multiple-outline';
import plusIcon from '@iconify/icons-mdi/plus';
import folderPlus from '@iconify/icons-mdi/folder-plus';
import imagePlus from '@iconify/icons-mdi/image-plus';
import viewGrid from '@iconify/icons-mdi/view-grid';
import formatListBulleted from '@iconify/icons-mdi/format-list-bulleted';
import twitterIcon from '@iconify/icons-mdi/twitter';
import instagramIcon from '@iconify/icons-mdi/instagram';
import facebookIcon from '@iconify/icons-mdi/facebook';
import starIcon from '@iconify/icons-mdi/star';
import timerOutline from '@iconify/icons-mdi/timer-outline';
import arrowUpBoldCircleOutline from '@iconify/icons-mdi/arrow-up-bold-circle-outline';
import linkVariant from '@iconify/icons-mdi/link-variant';
import linkedin from '@iconify/icons-mdi/linkedin';
import pinterest from '@iconify/icons-mdi/pinterest';

const presetIcons = {
  'lock': lockCheck,
  'lock-open': lockOpenVariant,
  'file-undo': fileUndo,
  'chevron-double-left': chevronDoubleLeft,
  'chevron-double-right': chevronDoubleRight,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-down': chevronDown,
  'chevron-up': chevronUp,
  'pause': pauseIcon,
  'play': playIcon,
  'replay': replayIcon,
  'check': checkIcon,
  'stop': stopIcon,
  'delete': deleteIcon,
  'undo': undoIcon,
  'alert': alertCircle,
  'database': databaseIcon,
  'tools': toolsIcon,
  'cog': cogIcon,
  'close': closeIcon,
  'cat': catIcon,
  'upload': arrowUpBoldCircleOutline,
  'trash': trashCan,
  'pencil': leadPencil,
  'dashboard': viewDashboard,
  'search': databaseSearch,
  'folder': folderIcon,
  'folder-open': folderOpen,
  'image-multiple-outline': imageMultipleOutline,
  'plus': plusIcon,
  'folder-plus': folderPlus,
  'image-plus': imagePlus,
  'view-grid': viewGrid,
  'format-list-bulleted': formatListBulleted,
  'twitter': twitterIcon,
  'instagram': instagramIcon,
  'facebook': facebookIcon,
  'star': starIcon,
  'timer-outline': timerOutline,
  'link': linkVariant,
  'linkedin': linkedin,
  'pinterest': pinterest
};

export default presetIcons;